import { getPathByRouteName } from '@core/tools';
import { LocationQuery, RouteRecordRaw } from 'vue-router';

export const indexPath = '/dashboard';

export * from './userAndMenusPlugin';

export * from './api';

export { default as CommonApp } from './src/CommonApp.vue';

export * from './src/components';

export * from './src/modules';

export * from './src/composables';

export * from './src/directive';

export * from './src/router';

export * from './src/layout';

export * from './src/stores/user';
export * from './src/stores/menus';
export * from './src/stores/tabs';

export interface ITab {
  /** tab对应的路由名称 */
  name: string;
  query: LocationQuery;
  state?: Record<string, any>;
  /** tab对应的document.title */
  title: string;
  /**
   * tab是否缓存
   * @default false
  */
  cache: boolean;
}

export const defaultTab: ITab = {
  query: {},
  name: indexPath.slice(1),
  title: '首页',
  cache: false,
};

export interface RouteConfig {
  name: string;
  parentName: string;
  title: string;
  cache?: boolean;
  component: any;
}

export const getVueRoutes = (items: RouteConfig[]) => {
  return items.map((v) => ({
    component: v.component,
    path: getPathByRouteName(v.name),
    name: v.name,
    meta: {
      title: v.title,
      cache: v.cache || false,
      parentName: v.parentName || undefined,
    },
  } as RouteRecordRaw));
};

export function previewOfficeFile(url: string) {
  if (__ENV_DEV__) {
    window.open(`${location.protocol}//${location.hostname}:${__LOGIN_APP_PORT__}/account/office-previewer?url=${url}`);
  } else {
    window.open(`/account/office-previewer?url=${url}`);
  }
}
